import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, catchError, map, throwError } from 'rxjs';
import { Product, ProductResponse, ProductsResponse } from './product.model';

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  readonly http = inject(HttpClient);
  path = 'restaurant/product/product';

  private handleError(err: any, error: string) {
    return throwError(() =>
      err.status === 400 ? err.error.msg : `Se ha producido un error: ${error}`
    );
  }

  getList(): Observable<Product[]> {
    return this.http.get<ProductsResponse>(`${this.path}`).pipe(
      map(resp => resp.data),
      catchError(err => this.handleError(err, 'Recuperar elementos'))
    );
  }

  getProduct(id: number): Observable<Product> {
    return this.http.get<ProductResponse>(`${this.path}/${id}`).pipe(
      map(resp => resp.data),
      catchError(err => this.handleError(err, 'Recuperar elemento'))
    );
  }

  // activeProduct(type: number, id: number): Observable<boolean> {
  //   return this.http
  //     .post<boolean>(`${this.path}/${type}/item/${id}/active`, null)
  //     .pipe(catchError((err) => this.handleError(err, 'Activar elemento')));
  // }

  addProduct(element: Product, image: File | null = null): Observable<Product> {
    const formData: FormData = new FormData();
    image && formData.append('image', image, image.name);
    formData.append('product', JSON.stringify(element));
    console.log(formData, element);
    
    return this.http
      .post<Product>(`${this.path}`, formData)
      .pipe(catchError(err => this.handleError(err, 'Añadir elemento')));
  }

  modifyProduct(
    element: Product,
    image: File | null = null
  ): Observable<Product> {
    const formData: FormData = new FormData();
    image && formData.append('image', image, image.name);
    formData.append(`product`, JSON.stringify(element));

    return this.http
      .put<Product>(`${this.path}/${element.restaurant_product_id}`, formData)
      .pipe(catchError(err => this.handleError(err, 'Modificar elemento')));
  }

  // addProduct(product: Product, image: File | null = null): Observable<Product> {
  //   const formData: FormData = new FormData();
  //   image && formData.append('image', image, image.name);
  //   formData.append('category', JSON.stringify(product));
  //   return this.http
  //     .post<Product>(`${this.path}`, formData)
  //     .pipe(catchError((err) => this.handleError(err, 'Añadir elemento')));
  // }

  // modifyProduct(product: Product, image: File | null = null): Observable<Product> {
  //   const formData: FormData = new FormData();
  //   image && formData.append('image', image, image.name);
  //   formData.append(`${this.path}`, JSON.stringify(product));
  //   return this.http
  //     .put<Product>(`${this.path}/${product.product_id}`, formData)
  //     .pipe(catchError((err) => this.handleError(err, 'Modificar elemento')));
  // }

  deleteProduct(product_id: number): Observable<boolean> {
    return this.http
      .delete<boolean>(`${this.path}/${product_id}`)
      .pipe(catchError(err => this.handleError(err, 'Eliminar elemento')));
  }
}
